import Dialog from 'core/modules/components/dialogs/components/Dialog';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './StatusModal.scss';

function StatusModal({ open, onClose, type = 'success' }) {
  const { t } = useTranslation(['chatbot']);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const isSuccess = type === 'success';
  const title = isSuccess ? t('error_report_success_title') : t('error_report_error_title');
  const message = isSuccess ? t('error_report_success_message') : t('error_report_error_message');

  return (
    <Dialog open={open} onClose={handleClose} size="xs" hideHeader className={`status-modal status-modal--${type}`}>
      <div className="status-modal__content">
        <div className="status-modal__icon">
          <div className={`status-modal__bot-icon status-modal__bot-icon--${type}`}></div>
        </div>
        <div className="status-modal__text">
          <h3 className={`status-modal__title status-modal__title--${type}`}>{title}</h3>
          <p className="status-modal__message">{message}</p>
        </div>
      </div>
    </Dialog>
  );
}

StatusModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['success', 'error']),
};

StatusModal.defaultProps = {
  type: 'success',
};

export default StatusModal;
